import React from "react";
import { Helmet } from "react-helmet-async";
import { useGetBookletQuery, useGetRandomRecipesQuery, useGetArticlesQuery } from "redux/contentApiSlice";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { FullWidthCta, CtaContent, CtaImage } from "@thrivetribe/mvf.ui.molecules.full-width-cta";
import { Body, BodyHeading, BodyContent } from "@thrivetribe/mvf.ui.organisms.body";
import { PageIntro } from "ui/atoms/PageIntro/PageIntro";
import RecipeCarousel from "ui/organisms/RecipeCarousel";
import ArticleCarousel from "ui/organisms/ArticleCarousel";
import "./FoodAndNutrition.scss";
import { LoadingSpinner } from "@thrivetribe/mvf.ui.molecules.loading-spinner";

export const FoodAndNutritionPage: React.FC = () => {
  const { data: booklet, isLoading: isBookletLoading } = useGetBookletQuery("food-as-fuel");
  const { data: recipes, isLoading: isRandomRecipeLoading } = useGetRandomRecipesQuery({
    breakfast: 2,
    main: 2,
    dessert: 1,
    snack: 1,
  });
  const { data: articles, isLoading: isArticlesLoading } = useGetArticlesQuery({
    limit: 6,
    pageRequested: 1,
    tagType: "pillarTags",
    tags: ["Nutrition"],
  });

  if (isBookletLoading || isRandomRecipeLoading || isArticlesLoading) {
    return <LoadingSpinner fullscreen={false} />;
  }

  return (
    <Body className="food-nutrition-page">
      <Helmet>
        <title>Food &amp; Nutrition - MAN v FAT</title>
      </Helmet>
      <BodyHeading>
        <h1>Food and nutrition</h1>
      </BodyHeading>

      <BodyContent>
        <PageIntro>
          Check out our recipes, articles, tips and guides that'll get you scoring healthy eating goals.
        </PageIntro>

        <h2 className="booklet__heading">Download our nutrition &amp; recipe guide</h2>
        {booklet !== undefined && (
          <FullWidthCta reactRouterTo={`https:${booklet.pdf.file.url}`} target="_blank">
            <CtaContent>
              <h2>{booklet.title}</h2>
              <p>{booklet.body}</p>
              <Button tabIndex={-1} onClick={() => {}} variant="text">
                {booklet.ctaCopy}
                <ButtonArrow />
              </Button>
            </CtaContent>
            <CtaImage url={booklet.asset.file.url} altText={booklet.asset.description} />
          </FullWidthCta>
        )}

        <RecipeCarousel recipes={recipes} />
        <ArticleCarousel articles={articles} />
      </BodyContent>
    </Body>
  );
};
